var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCustomers = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91458 8.52053C5.92217 9.88872 7.03677 10.9927 8.4042 10.9858C9.77314 10.9783 10.8763 9.86442 10.8695 8.49623C10.8634 7.12729 9.74809 6.02408 8.3799 6.03092C7.01171 6.03699 5.90775 7.15234 5.91458 8.52053Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3975 6.24136C13.4036 7.47364 14.4066 8.46752 15.6388 8.46068C16.8704 8.45461 17.8642 7.45163 17.8582 6.21935C17.8521 4.98783 16.8483 3.99395 15.6168 4.00003C14.3853 4.00686 13.3907 5.00984 13.3975 6.24136Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8977 19.9378C13.8833 16.468 11.4316 13.6678 8.42224 13.6853C5.41292 13.7027 2.98558 16.5302 3.00006 20L13.8977 19.9378Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2846 17.6696L19.393 17.6612L21.3807 17.6498C21.3728 15.8785 20.7298 14.281 19.7013 13.1444C19.4793 12.8999 19.2401 12.6759 18.9845 12.4762C18.7387 12.2841 18.4785 12.1148 18.2057 11.9705C17.8256 11.7686 17.4217 11.6152 17 11.518C16.6449 11.4368 16.2773 11.395 15.9004 11.3973",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCustomers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/customers.c4ed1216.svg";
export { ForwardRef as ReactComponent };